let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fcydO")).then(() => parcelRequire('lTt7V'));